import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from 'react-bootstrap';
import {StyledH3} from '@styled';

const CompleteView = ({viewType}) => {
  const [t] = useTranslation();
  const handleLogin = () => {
    window.location.href = '/login';
  };
  return (
    <div className="mt-5">
      <section className="content">
        <div className="container-fluid">
          <div className="card w-lg-40 mx-auto" style={{minHeight: '200px'}}>
            <div className="card-body">
              <StyledH3 className="mb-5 mt-0 text-center">
                {t('register.complete.title')}
              </StyledH3>
              <div className="text-center">
                {viewType === 'corporate' ? (
                  t('register.complete.description')
                ) : (
                  <div>
                    {t('register.complete.userDescription')}
                    <div className="mt-5">
                      <Button variant="link" size="sm" onClick={handleLogin}>
                        Click here to login
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CompleteView;
